// Enum must match the C# version
export const ArticleTypeEnum = Object.freeze({
  none: 0,
  news: 1,
  offer: 2,
  event: 3,
})
